// @core/api/endpoints/task/list_my_tasks.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTasksResponse,
} from '../../../types/task';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/task';

/**
 * List my tasks
 * Returns tasks across all products that are assigned to, created by, or watched by the current user. Useful for personal task dashboards.
 */
export async function ListMyTasks(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTasksResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/tasks/my`;
  const requestOptions = options;
  return client.get<ListTasksResponse>(requestPath, { ...requestOptions, params });
}
